var _path, _use, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowWhite = function SvgArrowWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 55",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "square",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.416 27.083a40.058 40.058 0 00-8.759 4.301c-6.856 4.489-11.244 10.824-13.157 19.002l4.545.804c2.073-6.971 5.903-12.335 11.485-16.087 5.345-3.591 13.223-5.446 21.412-5.601.17-.003-.17-.013 0-.014v-4.793c-8.189-.186-16.067-2.04-21.412-5.631-5.582-3.753-9.412-9.117-11.485-16.088l-4.545.805c1.913 8.176 6.301 14.513 13.157 19.002a40.1 40.1 0 008.759 4.3z",
    fill: "#fff"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 1,
    y: 24.746,
    width: 194,
    height: 5.857,
    transform: "matrix(1 0 0 .97611 0 0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: 194,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAAAGCAYAAACRmEGTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAASUlEQVRYhe3TMRGAMBjF4LRXN2hh7YQnTLChpw7w8SPjcUc+BVnSqmoHJtJ/nQPYgCNdIgXdPV0gfYEjSDiCBMAAFnClQ6Sg5wWoogfOO5PRGQAAAABJRU5ErkJggg=="
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-white.caa89c45.svg";
export { ForwardRef as ReactComponent };